module.exports = __webpack_public_path__ + "media/images/icon__link-c5d26ca75e0a72786bc7ac80c1801bbb.png";